import animateScrollTo from 'animated-scroll-to';
const chr = window.chrGlobal;

const anchorClick = () => {

  $( "a[href^='#']" ).not( "a[href='#'], .tabs a" ).click( function() {
    animateScrollTo( document.querySelector( $( this ).attr( 'href' ) ), {
      offset:
        ( window.innerWidth < chr.mobileNavBreak ) ? -chr.headerHeightMob : -chr.headerHeightDesk,
      speed: 1000,
    });
  });

};

const handleScrollDownArrow = () => {
  $( '.scroll-down-wrap' ).each( function() {
    let $arrowWrap = $( this );
    $arrowWrap.on( 'mouseenter', function() {
      $arrowWrap.addClass( 'in' );
    }).on( 'mouseleave', function() {
      $arrowWrap.removeClass( 'in' );
    });
    $arrowWrap.on( 'click', function() {
      const parent = $arrowWrap.closest( 'section' );
      $( 'html,body' ).animate({
        scrollTop: parent.offset().top + parent.outerHeight() - $( 'header' ).height()
      });
    });
  });
};

$( document ).ready( () => {
  anchorClick();
  handleScrollDownArrow();
});

/**
 * Scroll to given section
 * @param {Object} target - Target
 * @param {Integer} speed - Speed
 * @returns {Void} nothing
 */
export function scrollToSection( target, speed = 450 ) {

  $( window ).on( 'load', function() {
    if ( $( target ).length ) {
      let url = window.location.href;
      let slug = url.split( '#' )[1];
      if ( slug && slug !== 'all' ) {
        $( 'html,body' ).animate({
          scrollTop: $( target ).offset().top - $( 'header' ).height()
        }, speed );
      }
    }
  });
}
